import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uxp-photoshop-zh-cn/uxp-photoshop-zh-cn/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "sp-label"
    }}>{`sp-label`}</h1>
    <p><strong parentName="p">{`Since:`}</strong>{` UXP v4.1`}</p>
    <p>{`Renders a text label. Can also be used to add a label to many Spectrum UXP UI elements when using the `}<inlineCode parentName="p">{`slot="label"`}</inlineCode>{` attribute.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://spectrum.adobe.com/page/label"
        }}>{`https://spectrum.adobe.com/page/label`}</a></li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-label>This is a label</sp-label>
`}</code></pre>
    <h2 {...{
      "id": "attributes"
    }}>{`Attributes`}</h2>
    <p>{`You can indicate that a label is required by using the `}<inlineCode parentName="p">{`isrequired="true"`}</inlineCode>{` attribute.A`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-textfield>
    <sp-label slot="label" isrequired="true">This is a label</sp-label>
</sp-textfield>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      